import React from 'react';

export const SideCart = () => {
  return <div>SIDE CART</div>;
};
